// 原
// const relUtil = {
//   systemUrl: 'httpss://61.50.245.240:89/system',
//   supplierUrl: 'httpss://61.50.245.240:89/supplier',
//   businessUrl: 'httpss://61.50.245.240:89/business',
//   channelUrl: 'httpss://61.50.245.240:89/customer',
//   orderUrl: 'httpss://61.50.245.240:89/order',
//   loginUrl: 'httpss://61.50.245.240:89/security',
//   statisticalUrl: 'httpss://61.50.245.240:89/statistics',
//   activitiUrl: 'httpss://61.50.245.240:89/activiti',
//   orderquery: 'httpss://61.50.245.240:89/order',
// }
// const relUtil = {
//   systemUrl: 'httpss://api.test1.etoctop.cn/system',
//   supplierUrl: 'httpss://api.test1.etoctop.cn/supplier',
//   businessUrl: 'httpss://api.test1.etoctop.cn/business',
//   channelUrl: 'httpss://api.test1.etoctop.cn/customer',
//   orderUrl: 'httpss://api.test1.etoctop.cn/order',
//   loginUrl: 'httpss://api.test1.etoctop.cn/security',
//   statisticalUrl: 'httpss://api.test1.etoctop.cn/statistics',
//   activitiUrl: 'httpss://api.test1.etoctop.cn/activiti',
//   orderquery: 'httpss://api.test1.etoctop.cn/order',
// }
// export default relUtil
const path = 'https://api.manager.etoctop.cn'
const relUtil = {
  systemUrl: path+'/system',
  supplierUrl: path+'/supplier',
  businessUrl: path+'/business',
  channelUrl: path+'/customer',
  orderUrl: path+'/order',
  loginUrl: path+'/security',
  statisticalUrl: path+'/statistics',
  activitiUrl: path+'/activiti',
  orderquery: path+'/order',
}
export default relUtil

// const relUtil = {
//   systemUrl: 'httpss://61.50.245.240:93/system',
//   supplierUrl: 'httpss://61.50.245.240:93/supplier',
//   businessUrl: 'httpss://61.50.245.240:93/business',
//   channelUrl: 'httpss://61.50.245.240:93/customer',
//   orderUrl: 'httpss://61.50.245.240:93/order',
//   loginUrl: 'httpss://61.50.245.240:93/security',
//   statisticalUrl: 'httpss://61.50.245.240:93/statistics',
//   activitiUrl: 'httpss://61.50.245.240:93/activiti',
//   orderquery: 'httpss://61.50.245.240:93/order',
// }
// export default relUtil

// const relUtil = {
//   systemUrl: ' httpss://123.58.1.253:8888/system',
//   supplierUrl: ' httpss://123.58.1.253:8888/supplier',
//   businessUrl: ' httpss://123.58.1.253:8888/business',
//   channelUrl: ' httpss://123.58.1.253:8888/customer',
//   orderUrl: ' httpss://123.58.1.253:8888/order',
//   loginUrl: ' httpss://123.58.1.253:8888/security',
//   statisticalUrl: ' httpss://123.58.1.253:8888/statistics',
//   activitiUrl: ' httpss://123.58.1.253:8888/activiti',
//   orderquery: ' httpss://123.58.1.253:8888/order',
// }
// export default relUtil





// const relUtil = {
//   systemUrl: 'httpss://192.168.10.248:8888/system',
//   supplierUrl: 'httpss://192.168.10.248:8888/supplier',
//   businessUrl: 'httpss://192.168.10.248:8888/business',
//   channelUrl: 'httpss://192.168.10.248:8888/customer',
//   orderUrl: 'httpss://192.168.10.248:8888/order',
//   loginUrl: 'httpss://192.168.10.248:8888/security',
//   statisticalUrl: 'httpss://192.168.10.248:8888/statistics',
//   activitiUrl: 'httpss://192.168.10.248:8888/activiti',
//   orderquery: 'httpss://192.168.10.248:8888/order',
// };
// export default relUtil;






// WEBPACK FOOTER //
// ./src/utils/relUtil.js